import axios from "@/api/axios";

const API_URL = process.env.VUE_APP_API_HOST;

/**
 * @param {Object} params
 * @param {number[]} params.corporateGroupIds
 * @param {number} params.page
 * @param {number} params.perPage
 * @param {string} params.searchQuery
 * @param {boolean} params.reduced
 * @param {string[]} params.businessTypes
 * @param {AbortSignal} params.signal
 */
export async function getUnitsApi({
  corporateGroupIds,
  // page = 1,
  // perPage = 15,
  // searchQuery = "",
  // reduced = false,
  businessTypes,
  signal = null,
}) {
  return await axios.get(`${API_URL}/api/admin/companies`, {
    params: {
      "corporate-group-ids": corporateGroupIds,
      // "page[number]": page,
      // "page[size]": perPage,
      // search: searchQuery,
      // reduced: reduced,
      not_paginated: true,
      reduced: true,
      "business-types": businessTypes,
    },
    signal,
  });
}
